<template>
    <div>
        <div class="cd-section">
            <div style="display: flex; align-items: center; margin-left: 25px;">
                <span>Consider leads posted</span>
                <input v-model="date_from_days" type="number" class="form-control"
                       style="width: 100px; margin: 0 15px;"></input>
                <span>days before the hire date, and</span>
                <input v-model="date_to_days" type="number" class="form-control"
                       style="width: 100px; margin: 0 15px;"></input>
                <span>days after the hire date</span>
            </div>
            <div style="display: flex; align-items: center; margin-left: 25px;">
                <span style="width: 380px;">Consider leads sent to Employers:</span>
                <el-select v-model="employers" clearable multiple filterable
                           placeholder="Employers" style="width: 100%; margin: 5px 0;">
                    <el-option
                        v-for="(option) in employer_dropdown"
                        :key="option.id"
                        :label="option.name"
                        :value="option.id">
                    </el-option>
                </el-select>
            </div>
        </div>

        <div style="text-align: center; margin-top: 50px;">
            <btn cssClass="btn-primary btn-lg" icon="fas fa-cloud-upload-alt" :click="performHireValidation">Save and Process</btn>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'driver_upload_id',
        'employer_id'
    ],
    data() {
        return {
            employers: [parseInt(this.employer_id)],
            date_from_days: 270,
            date_to_days: 90,
            employer_dropdown: [],
        };
    },
    methods: {
        performHireValidation() {
            return axios.post(url(`admin/hire-report/process`), {
                'driver_upload_id': this.driver_upload_id,
                'apps_posted_from_days': this.date_from_days,
                'apps_posted_to_days': this.date_to_days,
                'consider_employers': this.employers
            }).then((response) => {
                window.location.href = url(`admin/employer/${this.employer_id}/hire-report/list`);
            });
        },
        refresh() {
            axios.get(url(`admin/employers/dropdown`))
                .then((response) => {
                    this.employer_dropdown = response.data;
                });
        }
    },
    mounted() {
        this.refresh();
    }
}
</script>
